import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store";
import * as echarts from "echarts";
import axios from 'axios'
import "./plugins/element.js";
import './assets/font/iconfont.css';
import './assets/iconfont/iconfont.css';
import VueI18n from "vue-i18n";
import './utility/global';
import VueDraggableResizable from "vue-draggable-resizable";
import "vue-draggable-resizable/dist/VueDraggableResizable.css";
import dataV from '@jiaminghi/data-view'
import setStream from './utils/downLoadStream'
// import { buttonPremiss } from './utility/index'


Vue.component("vue-draggable-resizable", VueDraggableResizable);
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || "zh",
  messages: {
    "en": require("./lang/en"),
    "zh": require("./lang/zh"),
  },
});
Vue.use(dataV)
Vue.filter('NumFormat', function (value) {
  if (!value) return ' '
  var intPart = Number(value).toFixed(0) 
  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') 
  return intPartFormat
}
);
Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false;

Vue.prototype.$axios = axios

Vue.prototype.$setStream = setStream

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");